module.exports = __webpack_public_path__ + "img/index10.6136b318.svg";